import { graphql } from "relay-runtime"

export const chConfirmDuplicatePatientsMutation = graphql`
  mutation chConfirmDuplicatePatientsMutation($input: Ch_confirmDuplicatePatientsInput!) {
    ch_confirmDuplicatePatients(input: $input) {
      ch_Patient {
        id
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
